import classes from "./Logo.module.scss";
import { ReactComponent as LogoSvg } from "../../../assets/images/logo.svg";
import { Link } from "react-router-dom";

const Logo = () => {
  return (
    <Link className={classes["logo"]} to="/">
      <LogoSvg className={classes["logo-img"]} />
      <strong className={classes["logo-text"]}>Lavina</strong>
    </Link>
  );
};

export default Logo;
